import { createSlice } from '@reduxjs/toolkit'

export const analysisPageNav = createSlice({
  name: 'analysisPageNav',
  initialState: {
    value: 'costs',
    loadingPDF: false
  },
  reducers: {
    assignAnalysisPageNav: (state, action) => {
      state.value = action.payload
    },
    assignLoadingPDF: (state, action) => {
      state.loadingPDF = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { assignAnalysisPageNav, assignLoadingPDF } = analysisPageNav.actions

export default analysisPageNav.reducer